import { __assign } from "tslib";
import React from "react";
import deepmerge from "deepmerge";
import { isSourceWithOptions, isRenderEngineWithOptions } from "../interfaces";
import { ErrorBoundary } from "./error-boundary";

function renderEngine(source, renderEngines, sourceGroupRenderEngineOptions) {
  var re = renderEngines.find(function (r) {
    if (isRenderEngineWithOptions(r)) {
      return r.renderEngine.sourceTypes.includes(source.source.type);
    }

    return r.sourceTypes.includes(source.source.type);
  });

  if (!re) {
    return null;
  }

  var renderE;

  if (isRenderEngineWithOptions(re)) {
    renderE = re;
  } else {
    renderE = {
      renderEngine: re,
      options: {}
    };
  }

  var Render = renderE.renderEngine.component;
  var renderEngineOptions = renderE.options;
  var sourceRenderEngineOptions = source.renderEngineOptions;
  var options = deepmerge.all([renderEngineOptions || {}, sourceGroupRenderEngineOptions || {}, sourceRenderEngineOptions || {}]);

  var s = __assign(__assign({}, source.source), {
    data: __assign({}, source.source.data)
  });

  return React.createElement(ErrorBoundary, null, React.createElement(Render, {
    source: s,
    options: options
  }));
}

function renderGroup(sources, renderEngines) {
  return __assign(__assign({}, sources), {
    sources: sources.sources.map(function (source) {
      return renderSingle(source, renderEngines, sources.renderEngineOptions);
    })
  });
}

function renderSingle(source, renderEngines, sourceGroupRenderEngineOptions) {
  if (source.source.data) {
    source.source.data.renderedContent = renderEngine(source, renderEngines, sourceGroupRenderEngineOptions);
  }

  return source;
}

function runRender(sources, renderEngines) {
  return sources.map(function (source) {
    if (isSourceWithOptions(source)) {
      return renderSingle(source, renderEngines);
    }

    return renderGroup(source, renderEngines);
  });
}

export { runRender };